"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var ReportButton = function ReportButton(_ref) {
  var className = _ref.className,
      isCustomer = _ref.isCustomer,
      onClick = _ref.onClick;
  return _react.default.createElement(_UITooltip.default, {
    disabled: isCustomer,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.loginRequired"
    })
  }, _react.default.createElement(_UIButton.default, {
    className: className,
    disabled: !isCustomer,
    onClick: onClick,
    use: "link"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.detail.reviews.report"
  })));
};

ReportButton.propTypes = {
  className: _propTypes.default.string,
  isCustomer: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func
};
var _default = ReportButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/reviews/ReportButton.js
// module id = 425
// module chunks = 209 210 211 212